/* istanbul ignore file */
export const enableCmcmMocks: boolean = (() => {
  try {
    return Boolean(
      JSON.parse(`${process.env.REACT_APP_ENALBE_CMCM_MOCKS}`) ?? false
    )
  } catch {
    return false
  }
})()

export const enableMarketplaceMocks: boolean = (() => {
  try {
    return Boolean(
      JSON.parse(`${process.env.REACT_APP_ENALBE_MARKETPLACE_MOCKS}`) ?? false
    )
  } catch {
    return false
  }
})()

export const enableAdminUIMocks: boolean = (() => {
  try {
    return Boolean(
      JSON.parse(`${process.env.REACT_APP_ENALBE_ADMIN_UI_MOCKS}`) ?? false
    )
  } catch {
    return false
  }
})()

export enum FeatureFlags {
  NEW_ONBOARDING_REDIRECTIONS = 'newOnboardingRedirections',
  LABRA_CUSTOMER_ONBOARDING = 'labraCustomerOnboarding',
  SAME_ORIGIN_API = 'sameOriginApi',
  SALESPIPELINE_AND_SYNC_HISTORY_API = 'salespipelineAndSyncHistoryApi',
}
